module.exports = __webpack_public_path__ + "credito-10-m-q9U.png";